import { Icon } from "@/components/lib";
import { useState } from "react";

export default function FullGalleryModal({ setOpen, items, startIndex }) {
  const [index, setIndex] = useState(startIndex || 0);

  const next = () =>
    setIndex((prev) => (prev + 1 < items.length ? prev + 1 : prev));
  const prev = () => setIndex((prev) => (prev - 1 >= 0 ? prev - 1 : prev));

  if (!items?.length) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-20 text-white">
      <button
        className="absolute top-60 md:top-5 right-5 bg-white text-black px-3 py-1 rounded z-[51]"
        onClick={() => setOpen(false)}
      >
        Close
      </button>
      {items[index].type === "video" ? (
        <video controls className="max-h-[80vh]" preload="auto" autoPlay>
          <source src={items[index].url} type="video/mp4" />
          “Your browser does not support the video tag.”
        </video>
      ) : (
        <img src={items[index].url} alt="selected" className="max-h-[80vh]" />
      )}
      {index > 0 && (
        <button
          onClick={prev}
          className="absolute left-4 md:left-8 top-1/2 transform -translate-y-1/2"
        >
          <Icon image="arrow-left-circle" size={50} />
        </button>
      )}
      {index < items.length - 1 && (
        <button
          onClick={next}
          className="absolute right-4 md:right-8 top-1/2 transform -translate-y-1/2"
        >
          <Icon image="arrow-right-circle" size={50} />
        </button>
      )}
    </div>
  );
}
